import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { useDocumentService } from "contexts/ServiceContext";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useDeliveryFiles = (): UseMutationResult<
  DocumentsFile[] | undefined,
  ApiStatusException,
  number | undefined
> => {
  const documentService = useDocumentService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useMutation({
    mutationKey: ["document-files", "deliveries"],
    mutationFn: (docEntry) => {
      const eventId = trackQuery({
        endpoint: "Delivery/GetFileUriList/{DocEntry}",
        parameters: { docEntry },
      });
      return docEntry
        ? documentService
            .getDeliveriesFileList(docEntry)
            .then((data) => data.value)
            .catch((err) => {
              trackQueryError(
                {
                  statusCode: err.statusCode,
                  message: err.message,
                },
                eventId
              );
              throw err;
            })
        : Promise.reject();
    },
  });
};

export default useDeliveryFiles;
